let scrollPos = window.scrollY;

let noConflictInit = function() {

	MicroModal.init({
		openClass: 'is-open', // [5]
		disableFocus: false, // [7]
		disableScroll: true,
	});

	MicroModal.init({
		onShow: modal => maybeAddVideoSource(modal),
		onClose: modal => maybeRemoveVideoSource(modal),
		openTrigger: 'data-video-modal-open',
		closeTrigger: 'data-video-modal-close',
		disableScroll: true,
		disableFocus: true,
	})

};

let modalOnShow = () => {
	document.body.classList.add('modal-open');
};

let modalOnClose = (e) => {
	document.body.classList.remove('modal-open');
	setCookie( 'snap-get-demo-popup', 'true', 1 );
};

let maybeAddVideoSource = function(modal) {
	let iframe = modal.getElementsByTagName('iframe');
	if ( iframe.length > 0 && !iframe[0].getAttribute('src') ) {
		iframe[0].setAttribute('src', iframe[0].getAttribute('data-video') + '?autoplay=1&rel=0');
	}
};

let maybeRemoveVideoSource = function(modal) {
	let iframe = modal.getElementsByTagName('iframe');
	if ( iframe.length > 0 ) {
		iframe[0].setAttribute('src', '');
	}
};

let checkPosition = () => {

	if ( getCookie('snap-get-demo-popup' ) ) {
		return;
	}

	let windowY = window.scrollY;
	if (scrollPos - windowY > 50) {
		MicroModal.show('scroll-up-popup', {
			onShow: modal => modalOnShow(modal),
			onClose: modal => modalOnClose(modal),
		});
	}
	scrollPos = windowY;
};

let debounce = (func, wait = 10, immediate = true) => {
	let timeout;
	return function() {
		let context = this, args = arguments;
		let later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		let callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

let getCookie = (name) => {
	let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	return v ? v[2] : null;
};

let setCookie = (name, value, days) => {
	let d = new Date;
	d.setTime(d.getTime() + 24*60*60*1000*days);
	document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
};


(() => {
	noConflictInit();

	let closedCookie = getCookie( 'snap-get-demo-popup' );
	if ( closedCookie ) {
		return;
	}

	let target = document.getElementById('scroll-up-popup');

	if ( !target ) {
		return;
	}

	window.addEventListener('scroll', debounce(checkPosition));
})();
